import request from "../utils/axios";

export const loginReq = (data) => {
  return request({ method: "POST", url: "/auth/signin", data });
};

export const verifyOtp = (data) => {
  return request({ method: "POST", url: "/auth/otp", data });
};

export const loginOtpReq = (data) => {
  return request({ method: "POST", url: "/auth/otp", data });
};

export const registerReq = (data) => {
  return request({ method: "POST", url: "/auth/register", data });
};
